import React from 'react';
import DisplayDocument from '../../../global/DisplayDocument';

const DisplayFields = ({ values, showDoc })=>{
  return (
    <div className="mx-2">
      <DisplayDocument 
        label="Government Approval Document"
        onClick={() => showDoc(values.governement_approval_document)}
        type="file"
        fileColClassName="document"
        documentLabel="Document"
        hasDocument={values.governement_approval_document ? true : false}
      />
      <DisplayDocument 
        label="Document showing business owners"
        onClick={() => showDoc(values.business_owner_document)}
        type="file"
        fileColClassName="document"
        documentLabel="Document"
        hasDocument={values.business_owner_document ? true : false}
      />
      <DisplayDocument 
        label="Corporate Address"
        type="text"
        textColClassName="document"
        value={values.corporate_address}
      />
      <DisplayDocument 
        label="Website"
        type="text"
        textColClassName="document"
        value={values.website_url}
      />
      <DisplayDocument 
        label="Email"
        type="text"
        textColClassName="document"
        value={values.email}
      />
    </div>
  )
};

export default DisplayFields;